import { useState } from "react";

import {
  IgTextField,
  type IgTextFieldProps,
} from "@intelligems/ig-theme/IgTextField";
import { InputAdornment } from "@mui/material";
import { useCurrency } from "@src/utils/useCurrency";

// Keeps the raw text while typing so "10." or "" aren't rewritten mid-edit.
export const DiscountValueInput = ({
  value,
  isPercentage,
  onChange,
  ...props
}: Omit<IgTextFieldProps, "value" | "onChange" | "type"> & {
  value: number | null | undefined;
  isPercentage: boolean;
  onChange: (value: number) => void;
}) => {
  const { symbol } = useCurrency();
  const [draft, setDraft] = useState<string | null>(null);

  return (
    <IgTextField
      {...props}
      value={draft ?? value ?? ""}
      type="number"
      onChange={(e) => {
        const next = e.target.value;
        const decimalIndex = next.indexOf(".");
        if (decimalIndex !== -1 && next.length - decimalIndex - 1 > 2) {
          return;
        }
        if (isPercentage && next !== "" && Number(next) > 100) {
          return;
        }
        setDraft(next);
        onChange(next === "" ? 0 : Number(next));
      }}
      onBlur={() => setDraft(null)}
      slotProps={{
        input: {
          startAdornment: isPercentage ? null : (
            <InputAdornment position="start">{symbol}</InputAdornment>
          ),
          endAdornment: isPercentage ? (
            <InputAdornment position="end">%</InputAdornment>
          ) : null,
        },
        htmlInput: { inputMode: "decimal" },
      }}
    />
  );
};
